export const imagesExtenstions = new Set([
  "jpeg",
  "jpg",
  "png",
  "gif",
  "webp",
  "svg",
  "bmp",
  "tiff",
  "heif",
  "heic",
  "ico",
  "jfif",
  "raw",
  "cr2",
  "nef",
  "orf",
  "sr2",
  "arw",
  "dng",
  "pef",
  "raf",
  "rw2",
  "psd",
  "ai",
  "eps",
  "xcf",
  "jxr",
  "wdp",
  "hdp",
  "jp2",
  "j2k",
  "jpf",
  "jpx",
  "jpm",
  "mj2",
  "avif",
]);

export const videosExtensions = new Set([
  "mp4",
  "avi",
  "mov",
  "mkv",
  "flv",
  "wmv",
  "webm",
  "mpg",
  "mpeg",
  "3gp",
  "m4v",
  "ts",
  "rm",
  "rmvb",
  "vob",
  "ogv",
  "dv",
  "qt",
  "asf",
  "m2ts",
  "mts",
  "divx",
  "f4v",
  "swf",
  "mxf",
  "roq",
  "nsv",
  "mvb",
  "svi",
  "mpe",
  "m2v",
  "mp2",
  "mpv",
  "h264",
  "h265",
  "hevc",
]);

export const documentsExtensions = new Set([
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "odt",
  "ods",
  "odg",
  "odp",
  "txt",
  "rtf",
  "csv",
  "epub",
  "md",
  "tex",
  "pages",
  "numbers",
  "key",
  "xml",
  "json",
  "yaml",
  "yml",
  "ini",
  "cfg",
  "conf",
  "log",
  "html",
  "htm",
  "xhtml",
  "djvu",
  "mobi",
  "azw",
  "azw3",
  "fb2",
  "lit",
  "ps",
  "wpd",
  "wps",
  "dot",
  "dotx",
  "xlt",
  "xltx",
  "pot",
  "potx",
  "oft",
  "one",
  "onetoc2",
  "opf",
  "oxps",
  "hwp",
]);
